import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { GeneralFooter } from "../../../components/generalFooter/GeneralFooter";
import { MooringMateHomeHeader } from "../../../components/HomeHeader/MooringMateHomeHeader";
import DockingmateHero from "../../../assets/dockingmate-login.jpeg";
import "./HowItWorks.css";
import { useNavigate } from "react-router-dom";
import { FiSearch, FiFileText, FiCreditCard, FiBarChart, FiDollarSign, FiPhoneCall, FiThumbsUp  } from "react-icons/fi";

export const HowItWorks = () => {
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <Box>
      <MooringMateHomeHeader />
      <Box className="page-title-section top-section" style={{ backgroundImage: `url(${DockingmateHero})` }}>
        <Box className="page-title-overlay"></Box>
        <Container maxWidth="lg">
          <Box style={{ textAlign: 'center' }}>
            <h1 className="page-heading">How It Works</h1>
          </Box>
        </Container>
      </Box>
      <Box className="intro-section">
        <Container maxWidth="lg">
        <Grid
            id="services"
            className="empowering"
            container
            spacing={2}
            style={{ paddingTop: "80px", paddingBottom: "40px" }}
          >
            <Grid item md={12} style={{ width: '100%' }}>
              <Box className="section-title centerd-title">
                <h2 className="title">How does it works?</h2>
                <p style={{ marginBottom: '20px' }}>Discover the easiest way to rent or list yacht moorings with our platform. Simple, secure, and designed for sailing enthusiasts.</p>
              </Box>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiSearch /></div>
                  <h3>1. Find the Perfect Mooring</h3>
                  <p>Easily browse available mooring spots based on location, amenities, and price. Instantly see all details, such as electricity access, security, and nearby facilities.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiFileText /></div>
                  <h3>2. List Your Mooring Online</h3>
                  <p>Have a mooring spot available? Upload it in just a few easy steps, set your price, and start renting it out. Maximize the return on your mooring!</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiCreditCard /></div>
                  <h3>3. Secure and Easy Payments</h3>
                  <p>Renters can pay directly through our platform. We ensure a secure payment process and clear financial administration.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiBarChart /></div>
                  <h3>4. Clear and Simple Administration</h3>
                  <p>No more paperwork hassle. We keep track of all bookings, payments, and contracts, so you can focus on sailing and enjoying the water.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box className="why-us-section">
        <Container maxWidth="lg">
        <Grid
            id="services"
            className="empowering"
            container
            spacing={2}
            style={{ paddingTop: "40px", paddingBottom: "80px" }}
          >
            <Grid item md={12}>
              <h2 className="title" style={{ textAlign: 'center' }}>Why Choose Our Platform?</h2>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiThumbsUp /></div>
                  <h3>1. Easy to use and quick setup</h3>
                  <p>Our intuitive platform makes listing or renting a breeze.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiCreditCard /></div>
                  <h3>2. Transparent and secure payments</h3>
                  <p>Peace of mind with every transaction.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiDollarSign /></div>
                  <h3>3. Higher returns on your mooring</h3>
                  <p>Maximize your investment with our platform.</p>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={4} sm={6} style={{ width: '100%' }}>
              <Card className="step-card" onClick={() => navigate("/login")} style={{ cursor: 'pointer' }}>
                <CardContent>
                  <div className="step-icon"><FiPhoneCall /></div>
                  <h3>4. Direct contact between renters and owners</h3>
                  <p>Build relationships with fellow sailing enthusiasts.</p>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Box>
      
      <Box className="cta-section">
        <Container maxWidth="lg">
          <Grid
            container
            spacing={3}
            sx={{
              alignItems: "center",
            }}
          >
            <Grid item md={12} style={{ width: '100%' }}>
              <Box style={{ textAlign: 'center' }}>
                <h2 className="title">Ready to Set Sail?</h2>
                <p className="sub-text">Start today and discover how easy it is to rent or lease a mooring!</p>
                <Button
                  onClick={() => navigate("/signup")}
                  className="btn-primary"
                  variant="contained"
                  color="primary"
                  size="large"
                >
                  Sign Up Now
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <GeneralFooter />
    </Box>
  );
};
